(function() {

    'use strict';



    var mimeTypes = [
        'video/mp4',
        'video/x-mp4',
        'video/webm',
        'video/ogg',
        'application/x-mpegurl'
    ];

    var arrIndexOf = SAPO.Utility.arrIndexOf;



    function Html5VideoBuilder(item, parentEl) {
        var vEl = document.createElement('video');
        vEl.setAttribute('type',     item.type);
        vEl.setAttribute('src',      item.src);
        vEl.setAttribute('autoplay', '');
        //vEl.setAttribute('controls', '');
        parentEl.appendChild(vEl);
        vEl.volume = 0.2; // TODO TEMP
    }



    function Html5VideoHdlr(item) { // isLinear must be true here...
        if (
            item.nodeName !== 'MediaFile' ||
            arrIndexOf(mimeTypes, item.type) === -1
        ) { return; }

        return {
            mimeType:    item.type,
            description: 'linear html5-powered video',
            item:        item,
            builder:     Html5VideoBuilder
        };
    }



    SAPO.Project.Video.VAST.handlers.Html5Video = Html5VideoHdlr;

})();
